import {
  hasAdminAccess,
  hasHubspotTicketAccess,
  type UserRole,
} from '../../utils/roleUtils';

export interface SidebarUtilityNavItem {
  id: 'dapps' | 'publishers' | 'reporting' | 'tickets' | 'aiSummaries';
  to: string;
  label: string;
}

const STAFF_ITEMS: SidebarUtilityNavItem[] = [
  { id: 'dapps', to: '/dapps', label: 'Dapps' },
  { id: 'publishers', to: '/publishers', label: 'Publishers' },
];

const ADMIN_ITEMS: SidebarUtilityNavItem[] = [
  { id: 'reporting', to: '/reporting', label: 'Reporting' },
  { id: 'tickets', to: '/tickets', label: 'Tickets' },
  { id: 'aiSummaries', to: '/ai-summaries', label: 'AI Summaries' },
];

/** ADMIN sidebar block. Alerts live on the publisher-card bell, not here. */
export function getSidebarUtilityNavItems(
  role: UserRole | null | undefined,
  email?: string | null,
): SidebarUtilityNavItem[] {
  if (role && hasAdminAccess(role, email)) {
    return [...STAFF_ITEMS, ...ADMIN_ITEMS];
  }

  if (role && hasHubspotTicketAccess(role, email)) {
    return [
      ...STAFF_ITEMS,
      { id: 'tickets', to: '/tickets', label: 'Tickets' },
    ];
  }

  return [];
}
